module.exports = __webpack_public_path__ + "media/images/app_icons/android-icon-48x48-59b144f9f5e20787881ef86690ba968b.png";